import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import CryptoJS from "crypto-js";

const EnterPinModal = ({ isOpen, onClose, onConfirm, storedEncryptedPin ,title}) => {
    const [enteredPin, setEnteredPin] = useState("");

    // Handle ESC key to close modal
    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27) {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEsc, false);
        }
        return () => {
            document.removeEventListener('keydown', handleEsc, false);
        };
    }, [isOpen, onClose]);

    // Handle clicking outside modal
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleConfirm = () => {
        try {
            console.log(storedEncryptedPin)
            // Decrypt the stored PIN
            const decryptedData = CryptoJS.AES.decrypt(storedEncryptedPin, "OctadevIPTV").toString(CryptoJS.enc.Utf8);
            const decryptedPin = JSON.parse(decryptedData).pin;

            if (enteredPin === decryptedPin) {
                onConfirm();
                onClose();
            } else {
                alert("Incorrect PIN!");
            }
        } catch (error) {
            alert("Error verifying PIN!");
        }
    };

    if (!isOpen) return null;

    return createPortal(
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className="modal-container">
                <div className="modal-header">
                    <h2 className="modal-title">{title}</h2>
                    <button className="modal-close" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <div className="modal-body">
                    <form className="playlist-form">
                        <div className="form-section">
                            <h3 className="section-title">Security Verification</h3>
                            
                            <div className="form-group">
                                <label className="form-label">PIN (4 Digits)</label>
                                <input
                                    type="password"
                                    className="form-input pin-input"
                                    maxLength="4"
                                    value={enteredPin}
                                    autoComplete="off"
                                    onChange={(e) => setEnteredPin(e.target.value.replace(/\D/g, ""))}
                                    placeholder="0000"
                                />
                            </div>
                        </div>
                    </form>
                </div>

                <div className="modal-footer">
                    <button onClick={onClose} className="btn btn-secondary">
                        <i className="fas fa-times"></i>
                        Cancel
                    </button>
                    <button onClick={handleConfirm} className="btn btn-primary">
                        <i className="fas fa-check"></i>
                        Confirm
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default EnterPinModal;
